import React, { useEffect, useState, useRef } from "react";
import { Nav } from "react-bootstrap";
import "./badges.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { ipfsToHttp } from "../../utils/ipfs";
import { API_URL } from "utils/ApiUrl";
import axios from "axios";
import Loader from "utils/loader";
import useFetchAdminStats from "hooks/useFetchAdminStats";
import useWeb3 from "hooks/useWeb3";

const Badges = ({ search, setSearch }) => {

  const web3 = useWeb3()

  console.log(search, setSearch, "searchsearchsearchsearch");
  const debounceTimeout = useRef(null);

  const adminDashboardStats = useFetchAdminStats();
  console.log(adminDashboardStats);

  const [activeTab, setActiveTab] = useState("link-1");
  const handleSelect = (eventKey) => {
    setActiveTab(eventKey);
  };
  const [show, setShow] = useState(false);

  // const [users, setUsers] = useState([]); 
  const [projects, setProjects] = useState();
  const [projectThumbs, setProjectThumbs] = useState({});
  const [offset, setOffset] = useState(1); // page number
  const [limit] = useState(10); // items per page
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const fetchProjects = async () => {
    setLoading(true);
    const accessToken = localStorage.getItem("token");


    // Determine whether the search is a wallet address or a name
    const isWalletAddress = web3.utils.isAddress(search);
    setLoading(true);


    // let queryParams = isWalletAddress
    //   ? { ...(search && { walletAddress: search }), offset, limit } // Only add walletAddress if search is not empty
    //   : { ...(search && { name: search }), offset, limit }; // Only add name if search is not empty
    // // Otherwise, add name
    let queryParams = search && search.trim() !== ""
      ? { name: search }
      : {};

    try {
      const response = await axios.get(`${API_URL}/projects`, {
        params: { ...queryParams, offset, limit: 20 },
        headers: {
          Authorization: `Bearer ${accessToken}`,
          // "content-type": "application/json",
        },
      });
      const data = response?.data?.data;
      // console.log("Transaction api response: ", response);
      console.log("projects activity : ", response?.data);
      setProjects(data?.projects);
      setTotalItems(data?.count); // Total number of items
      setTotalPages(data?.pages); // Total pages from API
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };


  // useEffect(() => {
  //   fetchProjects();
  //   if (search) {
  //     fetchProjects(search);
  //   }
  //   else if (search === "") {
  //     fetchProjects();
  //   }
  // }, [offset, limit, search]);
  useEffect(() => {
    if (search) {
      // Clear the previous timeout if the user continues typing
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      // Set a new timeout to trigger the fetch after 500ms
      debounceTimeout.current = setTimeout(() => {
        fetchProjects(search);
      }, 700); // Adjust delay time (in milliseconds) as needed
    } else if (search === "") {

      // If search is empty, fetch all projects
      fetchProjects();
    }


    // Cleanup function to clear timeout
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [search, offset, limit]);

  // Resolve `thumbnailImage` when it actually points to IPFS metadata (JSON) instead of an image.
  useEffect(() => {
    let cancelled = false;

    async function resolveThumb(project) {
      const raw = project?.thumbnailImage;
      if (!raw || typeof raw !== "string") return null;

      // If it already looks like a normal image URL, keep it.
      if (
        raw.startsWith("http://") ||
        raw.startsWith("https://") ||
        raw.startsWith("/")
      ) {
        return raw;
      }

      // First try to treat it as a direct IPFS asset.
      const direct = ipfsToHttp(raw);

      // Common pattern: folder CID where metadata is stored under filename "1"
      const metadataCandidate = raw.endsWith("/") ? `${raw}1` : raw;
      const metadataUrl = ipfsToHttp(metadataCandidate);

      try {
        const res = await fetch(metadataUrl, { cache: "no-store" });
        const ct = (res.headers.get("content-type") || "").toLowerCase();
        if (res.ok && (ct.includes("application/json") || ct.includes("text/plain"))) {
          const json = await res.json().catch(() => null);
          const image = json?.image;
          if (image && typeof image === "string") return ipfsToHttp(image);
        }
      } catch (e) {
        // ignore and fall back to direct
      }

      return direct;
    }

    async function run() {
      if (!Array.isArray(projects) || projects.length === 0) return;
      const updates = {};

      await Promise.all(
        projects.map(async (p) => {
          const key = p?._id || p?.id || p?.categoryIndex || p?.name;
          if (!key) return;
          const resolved = await resolveThumb(p);
          if (resolved) updates[key] = resolved;
        })
      );

      if (!cancelled && Object.keys(updates).length) {
        setProjectThumbs((prev) => ({ ...prev, ...updates }));
      }
    }

    run();
    return () => {
      cancelled = true;
    };
  }, [projects]);

  // Pagination logic
  const handlePageChange = (page) => {
    setOffset(page);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <section className="mainachievements ourteam ">
            <div className="mainsssparents">
              <div className="mainbadges d-none">
                <h2>Social Badges</h2>
                <div className="mainbadgescards">
                  <div className="innercards">
                    <div className="maincomntent">
                      <div className="mainimg">
                        <img
                          src="\assets\images\image2.svg"
                          alt="img"
                          className="img-fluid innerimg"
                        />
                      </div>
                      <h3>Follow on Twitter</h3>
                      <p>
                        Badge awarded for following the Prodex Twitter account
                      </p>
                      <button className="blue" onClick={handleShow}>
                        {" "}
                        Claim Badge
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="upperside">
                <div className="totalearningsss">
                  <div className="innerdivsss">
                    <div className="shoppingbags">
                      <img alt="bag" src="\assets\dashboard\Totalpojects.svg" />
                    </div>

                    <div>
                      <p>Total Projects</p>
                      <h6>{adminDashboardStats?.projectsCount}</h6>
                    </div>
                  </div>
                  {/* <h2>+2.3% since last month</h2> */}
                </div>
                <div className="totalearningsss">
                  <div className="innerdivsss">
                    <div className="shoppingbags">
                      <img alt="bag" src="\assets\dashboard\NFTsenerated.svg" />
                    </div>

                    <div>
                      <p>Fractions Generated</p>
                      <h6>{adminDashboardStats?.totalNftsGenerated}</h6>
                    </div>
                  </div>
                  {/* <h2>+2.3% since last month</h2> */}
                </div>
                <div className="totalearningsss">
                  <div className="innerdivsss">
                    <div className="shoppingbags">
                      <img alt="bag" src="\assets\dashboard\NFTssold.svg" />
                    </div>

                    <div>
                      <p>Fractions Sold</p>
                      <h6>{adminDashboardStats?.nftCount}</h6>
                    </div>
                  </div>
                  {/* <h2>+2.3% since last month</h2> */}
                </div>
                <div className="totalearningsss">
                  <div className="innerdivsss">
                    <div className="shoppingbags">
                      <img
                        alt="bag"
                        src="\assets\dashboard\NFTsavailable.svg"
                      />
                    </div>

                    <div>
                      <p>Fractions Available</p>
                      <h6>
                        {adminDashboardStats?.totalNftsGenerated -
                          adminDashboardStats?.nftCount}
                      </h6>
                    </div>
                  </div>
                  {/* <h2>+2.3% since last month</h2> */}
                </div>
              </div>

              <div className="mainouterdivproperties">
                <div className="rightfstt_aboutvvccc ">
                  <h3 className="myparxxa">Projects</h3>
                </div>
                <Link to="/admin/addnewproduct">


                  <button className="nnmoreproperties">
                    Create Project
                    <span>
                      {/* <svg  class="svgorange" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M3.75 9H14.25M14.25 9L9.75 4.5M14.25 9L9.75 13.5" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg> */}
                    </span>
                  </button>
                </Link>
              </div>

              <div className="ourteammainouter_div2">
                {/* <img src="https://ipfs.io/ipfs/QmV2AW9rG9Rmo3podpQ9QVLSK5XcorMHD419YsFMYoHk1f/1.jpg" /> */}

                {/* <Link to="/admin/addnewproduct"> */}
                {projects?.map((project, index) => {
                  const projectKey =
                    project?._id ||
                    project?.id ||
                    project?.categoryIndex ||
                    project?.name;
                  const resolvedThumb = projectThumbs[projectKey];
                  const rawThumb = project?.thumbnailImage;
                  const isDirectHttp =
                    typeof rawThumb === "string" &&
                    (rawThumb.startsWith("http://") ||
                      rawThumb.startsWith("https://"));
                  const thumbSrc =
                    resolvedThumb || (isDirectHttp ? rawThumb : "");

                  return (
                  <div key={index} className="maincarddiv" style={{ cursor: "pointer" }}>
                    <div className="zoom-container">
                      {thumbSrc ? (
                        <img
                          src={thumbSrc}
                          alt=""
                          className="imgcardddds"
                          loading="lazy"
                          onError={(e) => {
                            e.currentTarget.style.visibility = "hidden";
                          }}
                        />
                      ) : (
                        <div
                          className="imgcardddds"
                          aria-hidden
                          style={{ backgroundColor: "transparent" }}
                        />
                      )}
                    </div>

                    <div className="inercard_dta">
                      <div className="d-flex justify-content-between align-items-center">
                        <h1> {project.name}</h1>
                        {/* <h3 className="editbtmmm"> edit</h3> */}
                      </div>

                      <p>{project.location}</p>
                      <div className="iner_mainsssss">
                        <div className="cardds">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M6.28543 2.47571C6.28543 2.21187 6.07156 2 5.80971 2H2.47571C2.21187 2 2 2.21387 2 2.47571V5.80971C2 6.07356 2.21387 6.28543 2.47571 6.28543C2.73756 6.28543 2.95143 6.07156 2.95143 5.80971V2.95343H5.80772C6.07156 2.95343 6.28343 2.73956 6.28343 2.47771L6.28543 2.47571ZM17.7146 21.5243C17.7146 21.7881 17.9284 22 18.1903 22H21.5243C21.7881 22 22 21.7861 22 21.5243V18.1903C22 17.9264 21.7861 17.7146 21.5243 17.7146C21.2624 17.7146 21.0486 17.9284 21.0486 18.1903V21.0466H18.1923C17.9284 21.0466 17.7166 21.2604 17.7166 21.5223L17.7146 21.5243Z"
                              fill="#FF8A00"
                            />
                            <path
                              d="M20 18.5297V4.46832C20 4.20858 19.7754 4 19.5005 4H4.49954C4.22248 4 4 4.21055 4 4.46832V18.5317C4 18.7914 4.22458 19 4.49954 19H19.5005C19.7775 19 20 18.7895 20 18.5317V18.5297ZM19.0009 18.0614H4.99908V4.93664H18.9988V18.0614H19.0009Z"
                              fill="#FF8A00"
                            />
                            <path
                              d="M8.48725 13.9982C8.81209 13.9982 8.97451 13.85 8.97451 13.5518V12.0534C8.97451 11.7698 9.0476 11.5485 9.19174 11.3875C9.33589 11.2265 9.53485 11.146 9.7866 11.146C10.0079 11.146 10.1663 11.2064 10.2617 11.3271C10.3571 11.4479 10.4058 11.6381 10.4058 11.8997V13.5518C10.4058 13.85 10.5682 13.9982 10.8931 13.9982C11.2179 13.9982 11.3722 13.85 11.3722 13.5518V12.0534C11.3722 11.7698 11.4433 11.5485 11.5894 11.3875C11.7336 11.2265 11.9326 11.146 12.1843 11.146C12.4117 11.146 12.5721 11.2064 12.6675 11.3271C12.7629 11.4479 12.8096 11.6381 12.8096 11.8997V13.5518C12.8096 13.85 12.97 13.9982 13.2887 13.9982C13.6075 13.9982 13.776 13.85 13.776 13.5518V11.865C13.776 10.9301 13.3497 10.4636 12.499 10.4636C12.2148 10.4636 11.963 10.5221 11.7397 10.6411C11.5184 10.76 11.3478 10.9228 11.2301 11.1332C11.0555 10.6868 10.684 10.4636 10.1155 10.4636C9.85157 10.4636 9.62012 10.5166 9.41913 10.6209C9.21814 10.7252 9.05978 10.8716 8.94609 11.0563V10.9173C8.94609 10.6246 8.78976 10.4782 8.47304 10.4782C8.15633 10.4782 8 10.6246 8 10.9173V13.5536C8 13.8518 8.16039 14 8.47913 14L8.48725 13.9982ZM14.7282 9.75192C14.8033 9.7757 14.8865 9.7629 14.9799 9.71716C15.0632 9.67508 15.1505 9.64215 15.2439 9.61654C15.3372 9.59093 15.4266 9.57812 15.5139 9.57812C15.8123 9.57812 15.9626 9.69887 15.9626 9.94036C15.9626 10.0373 15.9362 10.1361 15.8813 10.2331C15.8265 10.33 15.7352 10.4398 15.6073 10.5606L14.8256 11.2997C14.7627 11.3546 14.714 11.4113 14.6794 11.4662C14.6429 11.5229 14.6246 11.5869 14.6246 11.6619C14.6246 11.7552 14.6591 11.8302 14.7282 11.8888C14.7972 11.9473 14.8845 11.9766 14.988 11.9766H16.667C16.8883 11.9766 17 11.8796 17 11.6839C17 11.4881 16.8883 11.3911 16.667 11.3911H15.6073L16.2813 10.7636C16.4661 10.5917 16.6 10.4343 16.6792 10.2898C16.7584 10.1453 16.799 9.99707 16.799 9.8434C16.799 9.58361 16.6995 9.37687 16.5006 9.22686C16.3016 9.07684 16.0316 9 15.6925 9C15.522 9 15.3494 9.02012 15.1748 9.05854C15.0002 9.09879 14.8439 9.15551 14.7099 9.22869C14.6165 9.27991 14.5597 9.34211 14.5394 9.41712C14.5191 9.49213 14.5272 9.55982 14.5617 9.62203C14.5982 9.68423 14.6531 9.72814 14.7282 9.75009V9.75192Z"
                              fill="#FF8A00"
                            />
                          </svg>
                          <h2>
                            {project.area} m<sup>2</sup>
                          </h2>
                        </div>
                        <div className="cardds">
                          <svg
                            className="imgsvgss"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M22.2266 11.12V7.23599C22.2255 6.2478 21.8325 5.30039 21.1338 4.60163C20.435 3.90287 19.4876 3.50985 18.4994 3.50879H5.485C4.49722 3.51048 3.55042 3.90379 2.85219 4.60248C2.15395 5.30116 1.76125 6.24821 1.7602 7.23599V11.1288C1.29568 11.343 0.902044 11.6855 0.625664 12.116C0.349284 12.5464 0.201666 13.0469 0.200195 13.5584V17.9648C0.200619 18.2771 0.324933 18.5765 0.545857 18.7973C0.766781 19.0181 1.06627 19.1422 1.3786 19.1424H2.7466V19.8912C2.7466 20.0503 2.80981 20.2029 2.92233 20.3155C3.03485 20.428 3.18747 20.4912 3.3466 20.4912C3.50573 20.4912 3.65834 20.428 3.77086 20.3155C3.88338 20.2029 3.9466 20.0503 3.9466 19.8912V19.1424H20.0546V19.8912C20.0546 20.0503 20.1178 20.2029 20.2303 20.3155C20.3429 20.428 20.4955 20.4912 20.6546 20.4912C20.8137 20.4912 20.9663 20.428 21.0789 20.3155C21.1914 20.2029 21.2546 20.0503 21.2546 19.8912V19.1424H22.6226C22.9348 19.142 23.2341 19.0178 23.4548 18.797C23.6756 18.5763 23.7998 18.277 23.8002 17.9648V13.5584C23.799 13.0439 23.6501 12.5406 23.3711 12.1083C23.0922 11.6761 22.6949 11.333 22.2266 11.12ZM2.9602 7.23599C2.96083 6.56634 3.22696 5.92427 3.70025 5.45054C4.17353 4.9768 4.81535 4.71006 5.485 4.70879H18.4994C19.1695 4.70942 19.8119 4.97589 20.2857 5.44969C20.7595 5.9235 21.026 6.56593 21.0266 7.23599V10.8704H19.101V9.19039C19.1006 8.63773 18.8809 8.10782 18.4902 7.71696C18.0995 7.3261 17.5697 7.10622 17.017 7.10559H14.6642C14.1115 7.10622 13.5816 7.32608 13.1907 7.71691C12.7999 8.10775 12.58 8.63766 12.5794 9.19039V10.8704H11.4138V9.19039C11.4132 8.63766 11.1933 8.10775 10.8025 7.71691C10.4116 7.32608 9.88172 7.10622 9.329 7.10559H6.9754C6.4235 7.10749 5.89482 7.3279 5.50502 7.71861C5.11522 8.10931 4.89603 8.63849 4.8954 9.19039V10.8704H2.9602V7.23599ZM17.9034 10.8704H13.7794V9.19039C13.7796 8.95579 13.8729 8.73086 14.0388 8.56497C14.2047 8.39909 14.4296 8.3058 14.6642 8.30559H17.017C17.2515 8.3058 17.4764 8.39911 17.6421 8.56502C17.8079 8.73093 17.901 8.95586 17.901 9.19039L17.9034 10.8704ZM10.2162 10.8704H6.0914V9.19039C6.0916 8.95662 6.18423 8.73241 6.34908 8.56666C6.51393 8.40091 6.73763 8.30707 6.9714 8.30559H9.325C9.55959 8.3058 9.78452 8.39909 9.95041 8.56497C10.1163 8.73086 10.2096 8.95579 10.2098 9.19039L10.2162 10.8704ZM20.6642 17.9448H20.6546H20.6442L3.4442 17.9624C3.41231 17.9529 3.37965 17.9462 3.3466 17.9424C3.31302 17.9462 3.27983 17.9529 3.2474 17.9624H1.4002V13.5584C1.40062 13.1639 1.55753 12.7856 1.83649 12.5067C2.11545 12.2277 2.49368 12.0708 2.8882 12.0704H21.1122C21.5067 12.0708 21.8849 12.2277 22.1639 12.5067C22.4429 12.7856 22.5998 13.1639 22.6002 13.5584L22.6226 17.9424L20.6642 17.9448Z"
                              fill="#FF8A00"
                            />
                          </svg>
                          <h2>{project.bedrooms} bedrooms</h2>
                        </div>
                        {/* <div className="cardds">
                                        <svg className="imgsvgss" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <g clip-path="url(#clip0_87_352)">
                                                <path d="M22.3953 13.0697H22.0873V4.49287C22.0914 3.6953 21.872 2.91253 21.4541 2.23324C21.0361 1.55394 20.4363 1.00527 19.7225 0.649386C19.0087 0.293498 18.2095 0.144614 17.4155 0.219602C16.6214 0.29459 15.8643 0.590452 15.2297 1.07367C14.3667 0.78535 13.4268 0.83281 12.5972 1.20659C11.7677 1.58037 11.1095 2.25302 10.7537 3.09047L10.6401 3.36007C10.5781 3.50382 10.5451 3.65838 10.5429 3.81492C10.5407 3.97146 10.5694 4.12689 10.6274 4.27231C10.6853 4.41774 10.7714 4.5503 10.8807 4.66241C10.9899 4.77453 11.1202 4.86399 11.2641 4.92567L15.7985 6.87527C15.9473 6.93869 16.1072 6.97161 16.2689 6.97207C16.5016 6.97117 16.7291 6.90264 16.9235 6.7748C17.118 6.64697 17.271 6.46535 17.3641 6.25207L17.4793 5.98327C17.7964 5.25844 17.8659 4.44934 17.6771 3.68105C17.4882 2.91277 17.0515 2.22809 16.4345 1.73287C16.9043 1.49565 17.4271 1.38315 17.9528 1.40615C18.4786 1.42916 18.9896 1.58691 19.4368 1.86425C19.884 2.1416 20.2525 2.52924 20.5067 2.98996C20.761 3.45069 20.8926 3.96904 20.8889 4.49527V13.0697H1.60572C1.2494 13.0701 0.907792 13.2118 0.655835 13.4638C0.403878 13.7157 0.262142 14.0573 0.261719 14.4137V16.4937C0.262722 17.598 0.564195 18.6812 1.13383 19.6273C1.70346 20.5733 2.51979 21.3465 3.49532 21.8641L2.81852 22.8625C2.77234 22.9276 2.73963 23.0013 2.7223 23.0792C2.70496 23.1571 2.70335 23.2377 2.71756 23.3163C2.73177 23.3949 2.76152 23.4698 2.80505 23.5367C2.84859 23.6036 2.90504 23.6612 2.97111 23.706C3.03717 23.7508 3.11151 23.782 3.18978 23.7977C3.26805 23.8135 3.34867 23.8134 3.42692 23.7976C3.50517 23.7818 3.57947 23.7505 3.64548 23.7056C3.71149 23.6607 3.76787 23.603 3.81132 23.5361L4.63212 22.3265C5.18788 22.4912 5.76444 22.5753 6.34412 22.5761H17.6561C18.2355 22.5752 18.8117 22.4914 19.3673 22.3273L20.1873 23.5361C20.2308 23.603 20.2872 23.6607 20.3532 23.7056C20.4192 23.7505 20.4935 23.7818 20.5717 23.7976C20.65 23.8134 20.7306 23.8135 20.8089 23.7977C20.8871 23.782 20.9615 23.7508 21.0275 23.706C21.0936 23.6612 21.15 23.6036 21.1936 23.5367C21.2371 23.4698 21.2669 23.3949 21.2811 23.3163C21.2953 23.2377 21.2937 23.1571 21.2763 23.0792C21.259 23.0013 21.2263 22.9276 21.1801 22.8625L20.5033 21.8649C21.4793 21.3475 22.296 20.5742 22.8659 19.628C23.4359 18.6818 23.7375 17.5983 23.7385 16.4937V14.4137C23.7381 14.0575 23.5965 13.716 23.3447 13.4641C23.0929 13.2121 22.7515 13.0703 22.3953 13.0697ZM16.3753 5.50647L16.2633 5.76807L11.7417 3.83127L11.8561 3.56327C12.046 3.12376 12.3602 2.74928 12.7599 2.48579C13.1597 2.22231 13.6277 2.0813 14.1065 2.08007C14.4454 2.0806 14.7805 2.15058 15.0913 2.28567C15.6882 2.54307 16.1586 3.02673 16.3994 3.63055C16.6401 4.23437 16.6314 4.90902 16.3753 5.50647ZM22.5353 16.4937C22.5332 17.7873 22.0184 19.0273 21.1037 19.942C20.1889 20.8567 18.9489 21.3716 17.6553 21.3737H6.34412C5.05051 21.3716 3.81049 20.8567 2.89577 19.942C1.98106 19.0273 1.46623 17.7873 1.46412 16.4937V14.4137C1.46412 14.3755 1.47929 14.3389 1.5063 14.3118C1.5333 14.2848 1.56993 14.2697 1.60812 14.2697H22.3953C22.4334 14.2699 22.4698 14.2851 22.4966 14.3121C22.5235 14.3391 22.5385 14.3756 22.5385 14.4137L22.5353 16.4937Z" fill="#FF8A00" />
                                                <path d="M10.9188 5.93294L10.226 6.68654C10.1289 6.80486 10.0807 6.95579 10.0913 7.10847C10.1018 7.26114 10.1703 7.40401 10.2827 7.50784C10.3952 7.61168 10.543 7.66863 10.696 7.66705C10.8491 7.66547 10.9957 7.60548 11.106 7.49934L11.7996 6.74574C11.9009 6.62751 11.9524 6.47455 11.9432 6.31909C11.9339 6.16364 11.8647 6.01784 11.7501 5.91244C11.6354 5.80704 11.4844 5.75026 11.3287 5.75409C11.173 5.75791 11.0249 5.82204 10.9156 5.93294H10.9188ZM12.2764 8.50494C12.3479 8.53854 12.4254 8.55768 12.5044 8.56126C12.5834 8.56484 12.6623 8.5528 12.7366 8.52582C12.811 8.49884 12.8792 8.45746 12.9375 8.40404C12.9958 8.35062 13.043 8.28623 13.0764 8.21454L13.4884 7.32974C13.5555 7.18546 13.5626 7.02042 13.5081 6.87091C13.4535 6.72141 13.3418 6.59969 13.1976 6.53254C13.0533 6.46539 12.8882 6.4583 12.7387 6.51284C12.5892 6.56737 12.4675 6.67906 12.4004 6.82334L11.9884 7.70734C11.9209 7.85132 11.9133 8.01619 11.9673 8.16574C12.0213 8.31529 12.1325 8.43729 12.2764 8.50494ZM14.3932 9.42814C14.5388 9.42801 14.6793 9.37494 14.7887 9.27882C14.898 9.18271 14.9687 9.05011 14.9876 8.90574L15.1196 7.89054C15.1399 7.73268 15.0968 7.5732 14.9995 7.44718C14.9023 7.32115 14.759 7.23891 14.6012 7.21854C14.4433 7.19817 14.2838 7.24135 14.1578 7.33857C14.0318 7.43578 13.9495 7.57908 13.9292 7.73694L13.798 8.75134C13.7879 8.82951 13.7933 8.9089 13.8138 8.98498C13.8344 9.06106 13.8698 9.13233 13.9179 9.19474C13.9661 9.25714 14.026 9.30945 14.0944 9.34868C14.1628 9.3879 14.2382 9.41327 14.3164 9.42334C14.3418 9.4265 14.3675 9.4281 14.3932 9.42814Z" fill="#FF8A00" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_87_352">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <h2>6 bathrooms</h2>
                                    </div> */}
                        <div className="cardds">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M14 3H20.6667C21.4027 3 22 3.59733 22 4.33333V5H14V4.33333C14 3.59733 14.736 3 14 3Z"
                              fill="white"
                            />
                            <path
                              d="M6 13.3333V4.33333C6 3.59733 6.57018 3 7.27273 3H20C19.2975 3 18.7273 3.59733 18.7273 4.33333V19.6667C18.7273 20.4027 18.1571 21 17.4545 21H6V20V13.3333Z"
                              fill="white"
                            />
                            <path
                              d="M18 21H3.3913C2.6233 21 2 20.4027 2 19.6667V19H16.6087V19.6667C16.6087 20.4027 17.232 21 18 21Z"
                              fill="white"
                            />
                            <path
                              d="M21.6667 5.33271C21.8507 5.33271 22.0001 5.18336 22.0001 4.99935V4.33261C22.0001 3.41318 21.2527 2.66577 20.3332 2.66577H13.6659C13.4819 2.66577 13.3325 2.81512 13.3325 2.99914C13.3325 3.18316 13.4819 3.33251 13.6659 3.33251H20.3332C20.8846 3.33251 21.3333 3.78122 21.3333 4.33261V4.99935C21.3333 5.18336 21.4827 5.33271 21.6667 5.33271Z"
                              fill="#FF8A00"
                            />
                            <path
                              d="M16.4994 20.6676H17.6661C18.2175 20.6676 18.6662 20.2189 18.6662 19.6675V4.33261C18.6662 3.95724 18.7909 3.6112 19.0003 3.33251H6.99838C6.44699 3.33251 5.99828 3.78122 5.99828 4.33261V7.66629C5.99828 7.85031 5.84893 7.99965 5.66491 7.99965C5.48089 7.99965 5.33154 7.85031 5.33154 7.66629V4.33261C5.33154 3.41318 6.07895 2.66577 6.99838 2.66577H20.3331C20.5171 2.66577 20.6665 2.81512 20.6665 2.99914C20.6665 3.18316 20.5171 3.33251 20.3331 3.33251C19.7817 3.33251 19.333 3.78122 19.333 4.33261V19.6675C19.333 20.5869 18.5856 21.3344 17.6661 21.3344H16.4994V20.6676Z"
                              fill="#FF8A00"
                            />
                            <path
                              d="M1.99805 19.6676V19.0008C1.99805 18.8168 2.1474 18.6675 2.33141 18.6675H16.3329C16.5169 18.6675 16.6662 18.8168 16.6662 19.0008V19.6676C16.6662 20.219 17.1149 20.6677 17.6663 20.6677C17.8503 20.6677 17.9997 20.817 17.9997 21.001C17.9997 21.1851 17.8503 21.3344 17.6663 21.3344H3.66489C2.74546 21.3344 1.99805 20.587 1.99805 19.6676ZM15.9995 19.6676V19.3342H2.66478V19.6676C2.66478 20.219 3.1135 20.6677 3.66489 20.6677H16.3335C16.1242 20.389 15.9995 20.0429 15.9995 19.6676ZM10.999 9.99991H11.6657C11.8497 9.99991 11.9991 9.85056 11.9991 9.66654C11.9991 9.48252 11.8497 9.33318 11.6657 9.33318H10.999C10.815 9.33318 10.6656 9.48252 10.6656 9.66654C10.6656 9.85056 10.815 9.99991 10.999 9.99991ZM12.9992 9.99991H13.6659C13.8499 9.99991 13.9993 9.85056 13.9993 9.66654C13.9993 9.48252 13.8499 9.33318 13.6659 9.33318H12.9992C12.8152 9.33318 12.6658 9.48252 12.6658 9.66654C12.6658 9.85056 12.8152 9.99991 12.9992 9.99991ZM14.9994 9.99991H16.9996C17.1836 9.99991 17.333 9.85056 17.333 9.66654C17.333 9.48252 17.1836 9.33318 16.9996 9.33318H14.9994C14.8154 9.33318 14.666 9.48252 14.666 9.66654C14.666 9.85056 14.8154 9.99991 14.9994 9.99991ZM13.6659 11.3334H16.9996C17.1836 11.3334 17.333 11.184 17.333 11C17.333 10.816 17.1836 10.6666 16.9996 10.6666H13.6659C13.4819 10.6666 13.3325 10.816 13.3325 11C13.3325 11.184 13.4819 11.3334 13.6659 11.3334ZM13.6659 8.66644H16.9996C17.1836 8.66644 17.333 8.51709 17.333 8.33307C17.333 8.14905 17.1836 7.99971 16.9996 7.99971H13.6659C13.4819 7.99971 13.3325 8.14905 13.3325 8.33307C13.3325 8.51709 13.4819 8.66644 13.6659 8.66644ZM11.6657 8.66644H12.3324C12.5165 8.66644 12.6658 8.51709 12.6658 8.33307C12.6658 8.14905 12.5165 7.99971 12.3324 7.99971H11.6657C11.4817 7.99971 11.3323 8.14905 11.3323 8.33307C11.3323 8.51709 11.4817 8.66644 11.6657 8.66644ZM9.6655 8.66644H10.3322C10.5163 8.66644 10.6656 8.51709 10.6656 8.33307C10.6656 8.14905 10.5163 7.99971 10.3322 7.99971H9.6655C9.48148 7.99971 9.33214 8.14905 9.33214 8.33307C9.33214 8.51709 9.48148 8.66644 9.6655 8.66644ZM10.999 7.33297H13.6659C13.8499 7.33297 13.9993 7.18362 13.9993 6.9996C13.9993 6.81558 13.8499 6.66623 13.6659 6.66623H10.999C10.815 6.66623 10.6656 6.81558 10.6656 6.9996C10.6656 7.18362 10.815 7.33297 10.999 7.33297ZM7.6653 7.33297H9.6655C9.84952 7.33297 9.99887 7.18362 9.99887 6.9996C9.99887 6.81558 9.84952 6.66623 9.6655 6.66623H7.6653C7.48128 6.66623 7.33193 6.81558 7.33193 6.9996C7.33193 7.18362 7.48128 7.33297 7.6653 7.33297ZM14.9994 7.33297H16.9996C17.1836 7.33297 17.333 7.18362 17.333 6.9996C17.333 6.81558 17.1836 6.66623 16.9996 6.66623H14.9994C14.8154 6.66623 14.666 6.81558 14.666 6.9996C14.666 7.18362 14.8154 7.33297 14.9994 7.33297ZM7.6653 5.9995H10.999C11.183 5.9995 11.3323 5.85015 11.3323 5.66613C11.3323 5.48211 11.183 5.33276 10.999 5.33276H7.6653C7.48128 5.33276 7.33193 5.48211 7.33193 5.66613C7.33193 5.85015 7.48128 5.9995 7.6653 5.9995ZM12.3324 5.9995H12.9992C13.1832 5.9995 13.3325 5.85015 13.3325 5.66613C13.3325 5.48211 13.1832 5.33276 12.9992 5.33276H12.3324C12.1484 5.33276 11.9991 5.48211 11.9991 5.66613C11.9991 5.85015 12.1484 5.9995 12.3324 5.9995ZM14.3327 5.9995H16.9996C17.1836 5.9995 17.333 5.85015 17.333 5.66613C17.333 5.48211 17.1836 5.33276 16.9996 5.33276H14.3327C14.1486 5.33276 13.9993 5.48211 13.9993 5.66613C13.9993 5.85015 14.1486 5.9995 14.3327 5.9995Z"
                              fill="#FF8A00"
                            />
                            <path
                              d="M6.99851 9.33374C6.53513 9.33374 6.08775 9.40375 5.66504 9.52976V13.3335V18.472C6.08775 18.598 6.53513 18.668 6.99851 18.668C9.57544 18.668 11.6657 16.5778 11.6657 14.0009C11.6657 11.424 9.57544 9.33374 6.99851 9.33374Z"
                              fill="white"
                            />
                            <path
                              d="M6.66532 17.668C9.0588 17.668 10.9991 15.7277 10.9991 13.3343C10.9991 10.9408 9.0588 9.00049 6.66532 9.00049C4.27184 9.00049 2.33154 10.9408 2.33154 13.3343C2.33154 15.7277 4.27184 17.668 6.66532 17.668Z"
                              fill="white"
                            />
                            <path
                              d="M7.33183 9.6665C4.93891 9.6665 2.99805 11.6074 2.99805 14.001C2.99805 15.0277 3.35742 15.9698 3.95415 16.7126C4.69689 17.31 5.63899 17.6687 6.66509 17.6687C9.058 17.6687 10.9989 15.7278 10.9989 13.3342C10.9989 12.3074 10.6395 11.3653 10.0428 10.6226C9.30003 10.0252 8.35793 9.6665 7.33183 9.6665Z"
                              fill="white"
                            />
                            <path
                              d="M6.64689 18.0107C5.40142 18.0107 4.2313 17.5266 3.35255 16.6472C1.80305 15.0984 1.53703 12.7175 2.70715 10.8586C2.80516 10.7026 3.01118 10.6572 3.16653 10.7539C3.32188 10.8519 3.36922 11.0579 3.27054 11.2133C2.26777 12.8075 2.49513 14.8483 3.82326 16.1758C4.57667 16.9292 5.57944 17.3439 6.64622 17.3439C6.64889 17.3439 6.65155 17.3439 6.65489 17.3439C7.72566 17.3419 8.73377 16.9226 9.49318 16.1631C10.2526 15.4037 10.672 14.3963 10.674 13.3248C10.676 12.2541 10.2613 11.2486 9.50585 10.4932C8.18971 9.17642 6.09416 8.95107 4.52067 9.95517C4.36532 10.0525 4.1593 10.0098 4.05995 9.85383C3.96128 9.69848 4.00661 9.49245 4.1613 9.39378C5.99615 8.22232 8.4424 8.48635 9.97723 10.0225C10.8587 10.9039 11.3434 12.0774 11.3407 13.3268C11.338 14.5756 10.8493 15.7504 9.96456 16.6352C9.0798 17.5199 7.90502 18.0093 6.65622 18.0113C6.65289 18.0107 6.65022 18.0107 6.64689 18.0107Z"
                              fill="#FF8A00"
                            />
                            <path
                              d="M6.66515 16.0011C7.59991 16.0011 8.33198 15.269 8.33198 14.3343C8.33198 13.5775 7.81793 13.0261 6.80449 12.6954L6.72915 12.6708C6.34911 12.5468 5.99841 12.3801 5.99841 12.0007C5.99841 11.608 6.27244 11.334 6.66515 11.334C7.13453 11.334 7.44789 11.586 7.45056 11.5887C7.59257 11.7073 7.80193 11.6887 7.92061 11.5487C8.03929 11.4073 8.02062 11.198 7.87994 11.0793C7.85993 11.0626 7.38255 10.6672 6.66515 10.6672C5.9044 10.6672 5.33167 11.2406 5.33167 12.0007C5.33167 12.9168 6.22777 13.2095 6.5218 13.3042L6.59714 13.3288C7.31655 13.5635 7.66525 13.8929 7.66525 14.3343C7.66525 14.9043 7.2352 15.3344 6.66515 15.3344C6.04641 15.3344 5.69238 14.9263 5.59837 14.801C5.48769 14.653 5.27834 14.6243 5.13165 14.7337C4.98364 14.8443 4.95364 15.053 5.06431 15.2004C5.20566 15.3891 5.73705 16.0011 6.66515 16.0011Z"
                              fill="#FF8A00"
                            />
                            <path
                              d="M6.66491 16.6678C6.84893 16.6678 6.99828 16.5185 6.99828 16.3345V16.0011C6.99828 15.8171 6.84893 15.6677 6.66491 15.6677C6.48089 15.6677 6.33154 15.8171 6.33154 16.0011V16.3345C6.33154 16.5185 6.48089 16.6678 6.66491 16.6678ZM6.66491 11.0006C6.84893 11.0006 6.99828 10.8512 6.99828 10.6672V10.3339C6.99828 10.1498 6.84893 10.0005 6.66491 10.0005C6.48089 10.0005 6.33154 10.1498 6.33154 10.3339V10.6672C6.33154 10.8512 6.48089 11.0006 6.66491 11.0006Z"
                              fill="#FF8A00"
                            />
                          </svg>
                          <h2>{project?.annualRentalIncome}%</h2>
                        </div>
                      </div>
                      <div className="botttom_side">
                        {/* <h3> 500,000</h3> */}
                        {/* <button>${project.annualRentalIncome}</button> */}
                        <button>${project.propertyPrice}</button>
                      </div>
                    </div>
                  </div>
                  );
                })}
                {/* </div> */}
              </div>
            </div>
          </section>
          <Modal className="claimed" show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Success</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="maincontent">
                <img
                  src="\assets\images\tick.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>New badge claimed successfully</p>
                <button onClick={handleClose} className="okay">
                  Okay
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default Badges;
